import { PureComponent } from 'react'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'

import withToast from 'src/components/Toast'
import { postRequest } from 'src/utils/request-client'
import { getErrorMessage } from 'src/utils/helpers'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'

class EmailConfirm extends PureComponent {
  state = {
    error: null,
    success: false,
  }

  componentDidMount() {
    const { intl, match, toast } = this.props
    const { vaultUserAccountId, confirmCode } = match.params

    postRequest(
      {
        base: '/vaultUser/confirm',
        mock: false,
      },
      {
        vaultUserAccountId,
        confirmCode,
      },
    )
      .then(() => {
        toast({
          title: intl.formatMessage(intlMessagesApp.appSuccessTitle),
          description: intl.formatMessage(intlMessages.authEmailConfirmSuccess),
          status: 'success',
        })
        this.setState({ success: true })
        // Optionally redirect after a delay if you want
        // setTimeout(() => this.props.history.push('/login'), 2000)
      })
      .catch(e => {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description: getErrorMessage(
            e,
            intl.formatMessage(intlMessages.authLoginNotificationUnableToLoginToken),
          ),
          status: 'warning',
        })
      })
  }

  render() {
    return null
  }
}

export default withRouter(injectIntl(withToast(EmailConfirm)))
